//GTM

$(function () {
  promotionViewAndClick();
  impressionViewAndClick();
  productDetailView();
  orderCompleteView();
});

//---------------------------------------------
//Index – Promotion List - Impression
//Index - Promotion List - Click
//---------------------------------------------
function promotionViewAndClick() {
  if ($('body').hasClass('page-index')) {
    promotionViewDataHandle();
    promotionClickDataHandle();
  }
}

function promotionViewDataHandle() {
  var eventName = 'promotionView';
  var ecommerce = {
    promoView: {
      promotions: []
    }
  };

  //find data
  var indexPushed = [];
  $('.swiper-slide').each(function (index, item) {
    var position = $(item).attr('data-index');
    var tempObject = {
      'id': $(item).attr('data-id'),
      'name': $(item).attr('data-title'),
      'href': $(item).find('a').attr('href'),
      'creative': 'Slide',
      'position': position,
    };
    if (indexPushed.indexOf(position) === -1) {
      ecommerce['promoView']['promotions'].push(tempObject);
      indexPushed.push(position)
    }

  });

  //push
  pushToDataLayer(eventName, ecommerce);
}

function promotionClickDataHandle() {
  var eventName = 'promotionClick';
  var ecommerce = {
    promoView: {
      promotions: []
    }
  };

  //find data
  $('.promotion-slide-href').click(function (e) {
    e.preventDefault();
    var targetItem = $(this).parents('.swiper-slide');
    var position = targetItem.attr('data-index');
    var tempObject = {
      'id': targetItem.attr('data-id'),
      'name': targetItem.attr('data-title'),
      'href': targetItem.find('a').attr('href'),
      'creative': 'Slide',
      'position': position,
    };
    ecommerce['promoView']['promotions'].push(tempObject);

    //push
    pushToDataLayer(eventName, ecommerce);

    //href change
    window.location.href = targetItem.find('a').attr('href');
  });

}
//---------------------------------------------
//Product List View – All Products
//Product List View – Click To Product Details
//Product List View – Per Category
//Product List View – Per Category – Click To Product Details
//---------------------------------------------
function impressionViewAndClick() {
  if ($('body').hasClass('page-allCake') || $('body').hasClass('page-allExpressCake') || $('body').hasClass('page-allDessert') || $('body').hasClass('page-allBread') || $('body').hasClass('page-category')) {
    impressionViewDataHandle();
    impressionClickDataHandle();
  }
}
function impressionViewDataHandle() {
  var eventName = 'impressionView';
  var ecommerce = {
    currencyCode: 'HKD',
    impressions: []
  };

  //find data
  var categoryName = $('.category-name-tc').attr('data-category');
  productList.forEach(function (item, index) {
    var tempObject = {
      'id': item['product']['pos_code'],
      'name': item['name_tc'],
      'price': item['price'],
      'position': index + 1,
      'list': categoryName,
    };
    ecommerce['impressions'].push(tempObject);
  })


  //push
  pushToDataLayer(eventName, ecommerce);
}
function impressionClickDataHandle() {
  var categoryName = $('.category-name-tc').attr('data-categor');

  var eventName = 'impressionClick';
  var ecommerce = {
    currencyCode: 'HKD',
    click: {
      actionField: {
        list: categoryName,
        action: 'click',
      },
      products: {}
    }
  };

  //find data
  $('.category-item-href').click(function (e) {
    e.preventDefault();
    var targetItem = $(this).parents('.item-container');
    var tempObject = {
      'id': targetItem.attr('data-posCode'),
      'name': targetItem.attr('data-name'),
      'price': targetItem.attr('data-price'),
      'position': targetItem.attr('data-position'),
      'list': categoryName,
    };
    ecommerce['click']['products'] = tempObject;

    //push
    pushToDataLayer(eventName, ecommerce);

    //href change
    window.location.href = targetItem.find('a').attr('href');
  });
}
//---------------------------------------------
//Product Detail Page
//---------------------------------------------
function productDetailView() {
  if ($('body').hasClass('page-product')) {
    productDetailViewDataHandle();
  }
}
function productDetailViewDataHandle() {
  var categoryName = $('.category-name-tc').attr('data-category');

  var eventName = 'productDetailView';
  var ecommerce = {
    currencyCode: 'HKD',
    detail: {
      actionField: {
        'list': categoryName
      },
      products: []
    }
  };

  //find price
  var productPrice = 0;
  if (productDetail['isFixedWeight']) {
    productPrice = productDetail['fixedPrice'];
  } else {
    productPrice = productDetail['weightOptions'][0]['weight'] * productDetail['weightOptions'][0]['price_per_weight'];
  }

  //find data
  var tempObject = {
    'id': productDetail['product']['pos_code'],
    'name': productDetail['product']['name_tc'],
    'price': productPrice,
    'list': categoryName,
  };
  ecommerce['detail']['products'].push(tempObject);

  //push
  pushToDataLayer(eventName, ecommerce);
}
//---------------------------------------------
// Order Complete (Step 3)
// Success Page – Purchase
//---------------------------------------------
function orderCompleteView() {
  if ($('body').hasClass('page-cartFinish') || $('body').hasClass('page-editFinish')) {
    checkoutStep3DataHandle();
    purchaseOrderDataHandle();
  }
}
function checkoutStep3DataHandle() {
  var eventName = 'checkout';
  var ecommerce = {
    checkout: {
      actionField: {
        step: 3
      }
    }
  };

  pushToDataLayer(eventName, ecommerce);
}
function purchaseOrderDataHandle() {
  var eventName = 'purchase';
  var ecommerce = {
    currencyCode: 'HKD',
    purchase: {
      actionField: {
        id: orderReferenceNumber ? orderReferenceNumber : '',
        affiliation: affiliation ? affiliation : '',
        revenue: revenue ? revenue : 0,
        shipping: shipping ? shipping : 0,
      },
      products: productList ? productList : [],
    }
  };

  pushToDataLayer(eventName, ecommerce);
}

//---------------------------------------------
//common 
function pushToDataLayer(eventName, ecommerce) {
  if (!eventName || !ecommerce) {
    return false;
  }

  var object = {
    event: eventName,
    ecommerce: ecommerce,
  };

  dataLayer.push(object);
}

